<template>
  <v-menu
    v-model="isOpen"
    role="menu-datepicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    :min-width="minWidth"
    :max-width="maxWidth"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDateValue"
        :label="label"
        readonly
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        @input.stop
      ></v-text-field>
    </template>
    <v-date-picker v-model="dateValue" :max="maxDate" @input="isOpen = false"></v-date-picker>
  </v-menu>
</template>

<script lang="ts">
import { getFormattedDate, getIsoFormattedDate } from '@/services/date-formater';
import Vue from 'vue';
export default Vue.extend({
  name: 'InputDatePicker',
  data() {
    return {
      isOpen: false,
      formattedDate: null
    };
  },
  props: {
    label: {
      type: String,
      required: true
    },
    maxDate: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    minWidth: {
      type: String,
      default: '290px'
    },
    maxWidth: {
      type: String,
      default: '290px'
    }
  },
  computed: {
    dateValue: {
      get(): string | null {
        if (this.date) {
          return getIsoFormattedDate(this.date);
        }

        return null;
      },
      set(newDate: string): void {
        this.$emit('input', newDate);
      }
    },
    formattedDateValue(): string | null {
      if (!this.dateValue) return null;

      return getFormattedDate(this.dateValue, '/');
    }
  }
});
</script>
